export default {
    SET_ONE_WEEK_OVERVIEWS(state, data) {
      state.mainOverviewsData = data;
    },
    SET_CUSTOM_CHART_DATA(state, data) {
      state.allData.chartData = data.data;
    },
    SET_ITEMS_MAIN(state, data) {
      state.itemsData = data
    },
    SET_ITEMS_TRAFFIC_DATA(state, data) {
      let i=0
      for(var element in data.datas[0]){
        for(let i = 0; i < data.datas[0][element].length; i++){
          for(var key in data.datas[0][element][i]){
            if(data.datas[0][element][i][key]===null){
              data.datas[0][element][i][key]='-'
            }
          }
        }
      }
      state.trafficData = data
    },
    SET_CHARTOPTIONS_DATA(state, {label,service,data, site,currency}){
      state.labelCurrency = label,
      state.selectedService = service
      state.selectedData = data
      state.optionSelectedService = service
      state.selectedSites = site
      state.selectedCurrency = currency
    },
    SET_GENERAL_TOTAL(state,total){
      state.generalTotal = total
    },
    SET_CURRENT_CURRENCY(state,{dolar,tl,ruble}){
      state.dolar = dolar.data
      state.tl = tl.data
      state.ruble = ruble.data
    },
    SET_REQUEST(state,req){
      state.request = req
    },
    SET_ONEDIOCOM_OVERVIEWS(state,{user,pageview,session,rate}){
      state.comUser=user
      state.comPageview=pageview
      state.comSession=session
      state.comRate=rate
    },
    SET_ONEDIOCO_OVERVIEWS(state,{user,pageview,session,rate}){
      state.coUser=user
      state.coPageview=pageview
      state.coSession=session
      state.coRate=rate
    },
    SET_ONEDIORU_OVERVIEWS(state,{user,pageview,session,rate}){
      state.ruUser=user
      state.ruPageview=pageview
      state.ruSession=session
      state.ruRate=rate
    },
    SET_BUTTON_ACTIVE(state,data){
      state.threeObject=data.a
      state.sevenObject=data.b
      state.fourTeenObject=data.c
      state.thirtyObject=data.d
      state.oneEightyObject=data.e
    },
    SET_USERNAME(state,username){
      state.userName=username
    },
    OVERVIEW_CHART(state,{overview,site}){
      state.overview=overview
      state.selectedSites=site
    },
    SET_SITE_SERVICE(state,{site,service}){
      state.optionSelectedService=service
      state.selectedSites=site
    },
    SET_SEARCH_DATE(state,{date1,date2}){
      state.date1=date1
      state.date2=date2
    },
   /*  SET_CACHED_DATAS(state,data){
      state.cachedData.push(data)
    }, */
    RESET_ALL(state,data) {
      Object.keys(state).forEach( key => {
        if(state[key]!==data[key]){
          state[key]=data[key]
        }
        
      })
    },
    
  }
  